
export const common = {
  'call.us': '联系我们',
  'privacy.policy': '隐私政策',
  'select.location': '选择您的位置',
  'location.description': '选择您的位置以拨打相应的电话号码',
  'usa': '美国',
  'non.usa': '非美国电话或WhatsApp',
  'documents.downloads': '文件和下载',
  'item': '项目',
  'value': '值',
  'price': '价格',
  'product': '产品',
  'msrp': '建议零售价',
};
